module.exports = __webpack_public_path__ + "static/media/exhibition-services-img18.b4d3a9d0.jpg";